export function createApi(httpClient) {
  async function getSuggestions(_ref, signal) {
    let {
      text,
      types,
      language,
      country,
      size
    } = _ref;
    const response = await httpClient.get('/geo/suggestions/geojson', {
      params: {
        text,
        country: country?.toUpperCase(),
        language,
        size,
        types: types?.join(',')
      },
      signal
    });
    return response.data;
  }
  return {
    getSuggestions
  };
}